<div class="col-sm-12 text-center">
    <img src="./assets/images/logo.png">
</div>
